import Counter_module_default from "./Counter.module.js";
import { jsx } from "react/jsx-runtime";
//#region src/Counter/index.tsx
const Counter = ({ count, warningColor = true }) => {
	const normalizedCount = count ?? 0;
	return /* @__PURE__ */ jsx("div", {
		className: Counter_module_default.wrapper,
		"data-warning-color": warningColor,
		children: normalizedCount > 99 ? "100+" : count || null
	}, normalizedCount);
};
//#endregion
export { Counter };

//# sourceMappingURL=index.js.map